export default __webpack_public_path__ + "static/media/fehlender-nachbarzahn.5fd20a4b.png";